require('../../modules/es6.reflect.get');
module.exports = require('../../modules/_core').Reflect.get;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/reflect/get.js
// module id = 581
// module chunks = 168707334958949